import * as React from 'react';
import { memo, useEffect, useState } from 'react';
import { PrinterOutlined } from '@ant-design/icons';
import { Card, Divider, Rate, Skeleton, Space, Tabs, Typography } from 'antd';
import { FullArticle, NoContentArticle } from '../admin-knowledge-base.type';
import { langLabels, languages } from '../admin-knowledge-base.constants';
import Button from '/react4xp/mixins/ui/button/button';
import { getById } from '../actions';
import { NO_DATA } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.constants';
import { round } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.utils';

interface ArticleViewProps {
    article: NoContentArticle;
}

const ArticleView = memo(({ article }: ArticleViewProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fullArticle, setFullArticle] = useState<FullArticle>(null);

    const scoreDescription = `Оценка: ${round(article.rating || 0) ?? NO_DATA}/5 (${
        article.scores || 'Нет оценок пользователей'
    })`;

    useEffect(() => {
        setIsLoading(true);
        getById<FullArticle>(article.id)
            .then(setFullArticle)
            .finally(() => setIsLoading(false));
    }, [article]);

    if (!fullArticle || isLoading) return <Skeleton />;

    return (
        <Tabs
            defaultActiveKey={languages[0]}
            items={languages.map((language) => ({
                key: language,
                label: langLabels[language],
                children: (
                    <Card style={{ position: 'relative', paddingTop: 65 }}>
                        <Typography.Title level={4}>{fullArticle[language].title}</Typography.Title>
                        <div
                            dangerouslySetInnerHTML={{ __html: fullArticle[language].content }}
                            style={{ wordBreak: 'break-all', wordWrap: 'break-word' }}
                        />
                        <Divider />
                        <Space direction="vertical">
                            <Space align="end">
                                <Rate
                                    allowHalf
                                    defaultValue={fullArticle.rating ?? 0}
                                    disabled
                                />
                                <span
                                    style={{
                                        color: '#EAB150',
                                        fontSize: 20,
                                        fontWeight: 700,
                                        lineHeight: 1,
                                    }}
                                >
                                    {round(fullArticle.rating) || NO_DATA}
                                </span>
                            </Space>
                            <div className="text-muted text-small">{scoreDescription}</div>
                        </Space>

                        <Button
                            icon={<PrinterOutlined />}
                            style={{ position: 'absolute', top: 16, right: 16 }}
                        >
                            Печать
                        </Button>
                    </Card>
                ),
            }))}
        />
    );
});

export default ArticleView;
